import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getInfrastructureTags(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].getInfrastructureTags,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function getInfrastructureTagsPreview(companyId, infrastructureTagsId) {
	return dataTransferWrap(ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].getInfrastructureTagsPreview, {
		urlParams: {
			companyId,
			infrastructureTagsId,
		},
	})
}

function createInfrastructureTags(companyId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].createInfrastructureTags,
		{
			urlParams: {
				companyId,
			},
			...data,
		},
	)
}

function getInfrastructureTag(companyId, infrastructureTagsId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].getInfrastructureTag,
		{
			urlParams: {
				companyId,
				infrastructureTagsId,
			},
		},
	)
}

function patchInfrastructureTags(companyId, infrastructureTagsId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].patchInfrastructureTags,
		{
			urlParams: {
				companyId,
				infrastructureTagsId,
			},
			...data,
		},
	)
}

function putInfrastructureTags(companyId, infrastructureTagsId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].putInfrastructureTags,
		{
			urlParams: {
				companyId,
				infrastructureTagsId,
			},
			...data,
		},
	)
}

function deleteInfrastructureTags(companyId, infrastructureTagsId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,dtConfig[ModulesMap.INFRASTRUCTURE_TAGS].deleteInfrastructureTags,
		{
			urlParams: {
				companyId,
				infrastructureTagsId,
			},
		},
	)
}

export default {
	getInfrastructureTags,
	getInfrastructureTagsPreview,
	getInfrastructureTag,
	patchInfrastructureTags,
	putInfrastructureTags,
	createInfrastructureTags,
	deleteInfrastructureTags,
}